import React, { Component } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Route } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';

import './Sidebar.css';

import { useStore } from '../store';
import Dashboard from '../app/dashboard';
import { Auth, Event } from '../support';
import AppSidebar from './sidebar/AppSidebar';
import { fetchAuthMe } from '../shared/session';
import StartHere from '../app/intro/StartHere';
import Emisores from '../app/emisores/Emisores';
import Usuarios from '../app/usuarios/Usuarios';
import GuardianRoute from '../shared/GuardianRoute';
import Receptores from '../app/receptores/Receptores';
import UsuariosInfo from '../app/usuarios/UsuariosInfo';
import EmisoresInfo from '../app/emisores/EmisoresInfo';
import Retenciones from '../app/retenciones/Retenciones';
import PageError403 from '../shared/errors/PageError403';
import Prefacturas from '../app/prefacturas/Prefacturas';
import HttpErrorMonitor from '../support/HttpErrorMonitor';
import Comprobantes from '../app/comprobantes/Comprobantes';
import SwitchEmpresas from '../app/empresas/SwitchEmpresas';
import UsuariosUpsert from '../app/usuarios/UsuariosUpsert';
import HitsUsage from '../app/reporting/hits-usage/HitsUsage';
import ReceptoresInfo from '../app/receptores/ReceptoresInfo';
import ReceptoresFile from '../app/receptores/ReceptoresFile';
import SendMailToSupport from './components/SendMailToSupport';
import ReceptoresExcel from '../app/receptores/ReceptoresExcel';
import FloatButtonSupport from './components/FloatButtonSupport';
import RetencionesInfo from '../app/retenciones/RetencionesInfo';
import EmisoresCsdUpdate from '../app/emisores/EmisoresCsdUpdate';
import ReceptoresUpsert from '../app/receptores/ReceptoresUpsert';
import ReceptoresUpload from '../app/receptores/ReceptoresUpload';
import NavBarHeader from './components/navbar-header/NavBarHeader';
import ComprobantesInfo from '../app/comprobantes/ComprobantesInfo';
import RetencionesCreate from '../app/retenciones/RetencionesCreate';
import PrefacturasInfo from '../app/prefacturas/info/PrefacturasInfo';
import PagosManagement from '../app/comprobantes/pagos/PagosManagement';
import ComprobantesCreate from '../app/comprobantes/ComprobantesCreate';
import EmisoresRegistration from '../app/emisores/EmisoresRegistration';
import EmisoresCustomization from '../app/emisores/EmisoresCustomization';
import EmisoresUpdateFiscalInfo from '../app/emisores/EmisoresUpdateFiscalInfo';
import UsuariosUpsertPermission from '../app/usuarios/UsuariosUpsertPermission';
import ReceptoresExcelInfo from '../app/receptores/excel/info/ReceptoresExcelInfo';
import FactorajeManagement from '../app/comprobantes/factoraje/FactorajeManagement';
import SessionOverrideHighlighter from '../shared/session/SessionOverrideHighlighter';
import EmisoresSoonToExpireHighlighter from '../app/emisores/EmisoresSoonToExpireHighlighter';
import AccountSuspendedHighlighter from '../admin/clientes/list/components/AccountSuspendedHighlighter';
import EmisoresSectorPrimarioUpdateFiscalInfo from '../app/emisores/EmisoresSectorPrimarioUpdateFiscalInfo';

class AppLayout extends Component {
  notification = null;

  state = {
    open: false,
    live: false,
  };

  _mounted = false;

  constructor(props) {
    super(props);

    const { empresa = {} } = Auth.getData() || {};

    this.state = {
      open: false,
      live: empresa.live || false,
    };

    this.setTenancy(empresa.live || false);

    window.flowIsLive = this.state.live;
  }

  componentDidMount() {
    window.setAppTitle('Mi cuenta');

    Event.on('go.live', this.goLive);
    Event.on('app.refresh', this.handleOnAppNeedsRefresh);
    Event.on('drawer.close', this.handleDrawerNeedsClose);
  }

  componentWillUnmount() {
    Event.off('go.live', this.goLive);
    Event.off('app.refresh', this.handleOnAppNeedsRefresh);
    Event.off('drawer.close', this.handleDrawerNeedsClose);
  }

  goLive = async () => {
    this.setState({
      busy: true,
    });

    try {
      const original = Auth.getData();

      const response = await fetchAuthMe();

      const user = {
        ...response.data,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const { empresa, emisor, cliente } = response.data;

      const data = {
        ...original,
        user,
        empresa,
        emisor: emisor || {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setTenancy(true);

      window.flowIsLive = true;

      this.setState({
        busy: false,
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.message || 'Error al sincronizar tu sesión',
      });
    }
  };

  handleDrawerNeedsClose = () => {
    this.setState({
      open: false,
    });
  };

  handleOnAppNeedsRefresh = () => {
    const { empresa = {} } = Auth.getData() || {};

    this.setState({
      live: empresa.live || false,
    });
  };

  setTenancy = (live) => {
    this.props.tenantActions.setPartialState({ data: { live } });
  };

  goToCompanySwitch = () => {
    this.props.history.push({
      pathname: '/app/switch',
      state: {
        from: this.props.location,
      },
    });

    this.handleOnToggleSidebar(false);
  };

  handleOnToggleSidebar = (state = null) => {
    state = state !== null ? state : !this.state.open;

    this.setState({
      open: state,
    });
  };

  goToActivation = () => {
    this.props.history.push('/cuenta/config/activacion');

    window.ToastManager.hide(this.notification);
  };

  handleOnTenancyChange = async (live) => {
    await this.props.tenantActions.live(live);

    const { error } = this.props.tenant;

    if (!error) {
      const {
        data: info,
        data: { live: tenancy },
      } = this.props.tenant;

      const original = Auth.getData();

      const data = {
        ...original,
        empresa: {
          ...info,
        },
      };

      Auth.setData(data);

      this.setTenancy(tenancy);

      await window.resetApp();

      if (live) {
        window.flowIsLive = true;
      }

      // Needed this line to allow the intro get updated for hits validation
      this.setState({});
    } else {
      if (error.code === 'account_not_activated') {
        this.setState({
          live: false,
        });

        this.notification = window.ToastManager.show({
          variant: 'info',
          title: 'Notificación',
          message: (
            <div>
              <div className="pb-2">{error.message}</div>
              <div className="text-right">
                <Button
                  type="button"
                  className="ml-auto"
                  onClick={() => this.props.history.push('/cuenta/config/activacion')}
                >
                  Ir a mi cuenta
                </Button>
              </div>
            </div>
          ),
        });
      } else {
        window.ToastManager.show({
          variant: 'info',
          title: 'Notificación',
          message: error.message,
        });
      }
    }
  };

  render() {
    const { open } = this.state;
    const {
      busy,
      data: { live = false },
    } = this.props.tenant;

    const sidebarClassName = !!open ? 'sidebar-open' : '';

    if (!Guardian.allows('app.access')) {
      return <PageError403 />;
    }

    return (
      <Container
        fluid
        className={`app-wrapper ${sidebarClassName}`}
      >
        <NavBarHeader
          fluid={false}
          onToggleSidebar={this.handleOnToggleSidebar}
        />

        <HttpErrorMonitor />

        <AccountSuspendedHighlighter />

        <EmisoresSoonToExpireHighlighter />

        <SessionOverrideHighlighter />

        <div
          className="sidebar-backdrop"
          onClick={this.handleOnToggleSidebar.bind(this, false)}
        ></div>

        <div className="d-block d-lg-none d-xl-none">
          <AppSidebar
            live={live}
            open={open}
            busy={busy}
            onCompanyClick={this.goToCompanySwitch}
            onTenancyChange={this.handleOnTenancyChange.bind(this)}
            onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
          />
        </div>

        <div className="app-container container">
          <div className="d-none d-lg-flex d-xl-flex">
            <AppSidebar
              live={live}
              open={open}
              busy={busy}
              onCompanyClick={this.goToCompanySwitch}
              onTenancyChange={this.handleOnTenancyChange.bind(this)}
              onMenuItemClick={this.handleOnToggleSidebar.bind(this, false)}
            />
          </div>

          <div className="main-container">
            <div className="page-container">
              {/* <Counter /> */}

              <Route
                path="/app/intro"
                component={StartHere}
                exact
              />
              <Route
                path="/app/dashboard"
                component={Dashboard}
                exact
              />
              <Route
                path="/app/switch"
                component={SwitchEmpresas}
                exact
              />

              <Route
                path="/app/receptores"
                component={Receptores}
                can="receptor.listar"
                exact
              />
              <GuardianRoute
                path="/app/receptores/registrar"
                component={ReceptoresUpsert}
                can="receptor.crear"
                exact
              />
              <Route
                path="/app/receptores/:id/info"
                component={ReceptoresInfo}
                can="receptor.info"
                exact
              />
              <GuardianRoute
                path="/app/receptores/:id/editar"
                component={ReceptoresUpsert}
                can="receptor.editar"
                exact
              />
              <GuardianRoute
                path="/app/receptores/archivos"
                component={ReceptoresFile}
                can="receptor.listar.archivos"
                exact
              />
              <GuardianRoute
                path="/app/receptores/upload"
                component={ReceptoresUpload}
                can="receptor.crear.excel"
                exact
              />
              <GuardianRoute
                path="/app/receptores/excel"
                component={ReceptoresExcel}
                can="receptor.listar.excel"
                exact
              />
              <GuardianRoute
                path="/app/receptores/excel/:id/info"
                component={ReceptoresExcelInfo}
                can="receptor.info.receptores.excel"
                exact
              />

              <GuardianRoute
                path="/app/emisores"
                component={Emisores}
                can="emisor.listar"
                exact
              />
              <GuardianRoute
                path="/app/emisores/registrar"
                component={EmisoresRegistration}
                can="emisor.crear"
                exact
              />
              <GuardianRoute
                path="/app/emisores/:id/info"
                component={EmisoresInfo}
                can="emisor.info"
                exact
              />
              <GuardianRoute
                path="/app/emisores/:id/editar"
                component={EmisoresUpdateFiscalInfo}
                can="emisor.editar"
                exact
              />
              <GuardianRoute
                path="/app/emisores/:id/personalizar"
                component={EmisoresCustomization}
                can="emisor.personalizar"
                exact
              />
              <GuardianRoute
                path="/app/emisores/:id/certificados"
                component={EmisoresCsdUpdate}
                can="emisor.actualizar.csd"
                exact
              />

              <GuardianRoute
                path="/app/emisores/sector-primario/:id/editar"
                component={EmisoresSectorPrimarioUpdateFiscalInfo}
                can="emisor.editar"
                exact
              />

              <GuardianRoute
                path="/app/comprobantes"
                component={Comprobantes}
                can="factura.listar"
                exact
              />

              <GuardianRoute
                path="/app/comprobantes/timbrado"
                component={ComprobantesCreate}
                can="factura.crear"
                exact
              />
              <GuardianRoute
                path="/app/comprobantes/:uuid/info"
                component={ComprobantesInfo}
                can="factura.info"
                exact
              />
              <GuardianRoute
                path="/app/comprobantes/:uuid/pagos"
                component={PagosManagement}
                can="administrar_pagos.access"
                exact
              />

              <GuardianRoute
                path="/app/comprobantes/:uuid/factoraje"
                component={FactorajeManagement}
                can="factoraje_financiero.access"
                exact
              />

              {Guardian.allows('prefacturas.access') && (
                <>
                  <GuardianRoute
                    path="/app/prefacturas"
                    component={Prefacturas}
                    can="prefactura.listar"
                    exact
                  />

                  <GuardianRoute
                    path="/app/prefacturas/:id/info"
                    component={PrefacturasInfo}
                    can="prefactura.info"
                    exact
                  />
                </>
              )}

              <GuardianRoute
                path="/app/retenciones"
                component={Retenciones}
                can="retenciones.access"
                exact
              />
              <GuardianRoute
                path="/app/retenciones/timbrado"
                component={RetencionesCreate}
                can="retencion.crear"
                exact
              />
              <GuardianRoute
                path="/app/retenciones/:uuid/info"
                component={RetencionesInfo}
                can="retencion.info"
                exact
              />

              <GuardianRoute
                path="/app/consumo-hits"
                component={HitsUsage}
                can="hits.listar"
                exact
              />

              {Guardian.allows('usuarios.access') && (
                <>
                  <GuardianRoute
                    path="/app/usuarios"
                    component={Usuarios}
                    can="usuario.listar"
                    exact
                  />
                  <GuardianRoute
                    path="/app/usuarios/registrar"
                    component={UsuariosUpsert}
                    can="usuario.crear"
                    exact
                  />
                  <GuardianRoute
                    path="/app/usuarios/:id/editar"
                    component={UsuariosUpsert}
                    can="usuario.editar.informacion"
                    exact
                  />
                  <GuardianRoute
                    path="/app/usuarios/:id/info"
                    component={UsuariosInfo}
                    can="usuario.info"
                    exact
                  />
                  <GuardianRoute
                    path="/app/usuarios/:id/permisos"
                    component={UsuariosUpsertPermission}
                    can="usuario.editar.permisos"
                    exact
                  />
                </>
              )}

              <Route
                path="/app/send-mail-support"
                component={SendMailToSupport}
                exact
              />
            </div>
          </div>
        </div>

        <FloatButtonSupport />
      </Container>
    );
  }
}

const mapState = (store) => {
  return { tenant: store.layouts.empresa.tenant };
};

const mapActions = (actions) => {
  return { tenantActions: actions.layouts.empresa.tenant };
};

export default connect(useStore, mapState, mapActions)(AppLayout);
